module.exports = __webpack_public_path__ + "img/DE02363.2132e523.png";